import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testing"]
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "sidebar-top" }
const _hoisted_4 = ["data-testing"]
const _hoisted_5 = { class: "right-sidebar-body no-sticky-buttons" }

import { mdiClose } from "@mdi/js";
import { PropType } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RightSidebar',
  props: {
  isUpdating: {
    type: Boolean,
    default: false,
    required: false
  },
  isCloseBtnVisible: {
    default: true,
    required: false,
    type: Boolean
  },
  dataTesting: {
    type: String,
    required: false,
    default: ""
  },
  closeBtnDataTesting: {
    type: String,
    required: false,
    default: "close-assets-sidebar-btn"
  },
  cssClasses: {
    type: Array as PropType<string[]>,
    required: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'right-sidebar',
      { updating: __props.isUpdating, 'no-close-btn': !__props.isCloseBtnVisible },
      ...__props.cssClasses
    ]),
    "data-testing": __props.dataTesting
  }, [
    _renderSlot(_ctx.$slots, "additional-content"),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "expand-btn"),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title"),
        _renderSlot(_ctx.$slots, "dropdown"),
        (__props.isCloseBtnVisible)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "close-btn btn-3",
              title: "close",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeSidebar'))),
              "data-testing": __props.closeBtnDataTesting
            }, [
              _createVNode(_component_SVGIcon, {
                path: _unref(mdiClose),
                type: "is-white",
                size: 24
              }, null, 8, ["path"])
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "body")
      ])
    ]),
    _renderSlot(_ctx.$slots, "modals")
  ], 10, _hoisted_1))
}
}

})